<template>
    <el-popover
            v-if="remarks.length > 0"
            placement="left"
            width="480"
            trigger="hover">

        <el-timeline :reverse="true">
            <el-timeline-item
                    v-for="(remark, index) in remarks"
                    :key="index"
                    :timestamp="remark.created_username+ ' 提交于 '  + remark.created_time">
                {{remark.content}}
            </el-timeline-item>
        </el-timeline>
        <el-tag slot="reference" type="danger" size="mini">{{ remarks.length }}条</el-tag>
    </el-popover>


</template>

<script>
    export default {
        name: "ProRemark",
        props: {
            proRequirement: {
                type: Object,
                required: true,
            },
        },
        computed: {
            remarks() {
                return this.proRequirement.prremark_set
            },
        },
    }
</script>

<style scoped>

</style>